import React from "react";
import userImg from "../../../resources/images/app/header/user.png";
import orangeLogo from "../../../resources/images/app/branding/new-logo.svg";


export default function MobileNavigationMenu({isOpen, partnerName}) {

    return (
        <>
            <div className="only-mobile-logo">
                <img src={orangeLogo} alt="" className="logo-icon" />
            </div>
            <div className={"mobile-menu" + (isOpen ? " open" : "")}>
                <div className={"mobile-menu-content" + (isOpen ? " open" : "")}>
                        <div className="mobile-menu-header">
                            <div className="mail">
                                <div className="icona">
                                    <img src={userImg} alt="" />
                                </div>
                                <span className="amount">{partnerName}</span>
                            </div>
                        </div>
                </div>
            </div>
        </>
    );
}
